import React from "react";
import { UserProvider } from "../UserContext";
import { Routes, Route } from "react-router-dom";
import { Header } from "../components/Header";
import Register from "../pages/Signup/index";
import Login from "../pages/Login/index";
import Home from "../pages/Home/index"
import PasswordReset from "../pages/PasswordReset/index";
import NewTripForm from "../pages/NewTripForm";
import Forget from "../pages/ForgetPassword";
import ItineraryPage from "../pages/ItineraryPage";




export const Navigation = () => {
    return (
        <UserProvider>
            <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/create-trip" element={<NewTripForm />} />
                    <Route path="/forget-password" element={<Forget />}  />
                    <Route path="/reset-password" element={<PasswordReset />}  />
                    <Route path="/itinerary" element={<ItineraryPage />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/login" element={<Login />}  />
                </Routes>
        </UserProvider>
    );
};